import { twMerge } from 'tailwind-merge';

type Props = {
  selected: boolean;
  onClick?: () => void;
  value?: string;
  children: React.ReactNode;
};

export function ToggleButton({ selected, onClick, children }: Props): JSX.Element {
  const defaultClasses =
    'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10';
  const finalClasses = twMerge(defaultClasses, selected ? 'bg-primary-600/40' : '');

  return (
    <button onClick={onClick} type="button" className={finalClasses}>
      {children}
    </button>
  );
}
